import { Injectable } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Injectable({
  providedIn: 'root'
})
export class UiBlockService {
  @BlockUI() blockUI: NgBlockUI;

  waitingOnProgress: number = 0;

  private blockTimeoutId: any = null;
  private readonly DEFAULT_TIMEOUT = 3 * 60 * 1000; // 3 minutes in milliseconds

  constructor() { }

  public startBlockWaitForProgress(message : string) : void{
    this.startBlock(message, null);
    this.waitingOnProgress++;
  }

  public stopBlockWaitForProgress() : void{
    if (this.waitingOnProgress < 0){
      this.waitingOnProgress = 0;
    }
    if (this.waitingOnProgress == 0){
      return;
    }
    this.stopBlock(false);
    this.waitingOnProgress--;
  }

  public startBlock(message: string, timeout = this.DEFAULT_TIMEOUT): void {
    if (this.blockUI) {
      this.blockUI.start(message);

      if (timeout) {
        this.clearBlockTimeout();
        // Set a timeout to automatically stop the block
        this.blockTimeoutId = setTimeout(() => {
          this.forceStopBlock();
        }, timeout);
      }
    }
  }    

  public stopBlock(timeout = true) : void{
    if(this.blockUI)
      this.blockUI.stop();
    if (timeout)
      this.clearBlockTimeout();
  }


  private forceStopBlock(): void {
    if (this.blockUI) {
      this.blockUI.stop();
    }

    this.clearBlockTimeout();
  }

  private clearBlockTimeout(): void {
    if (this.blockTimeoutId) {
      clearTimeout(this.blockTimeoutId);
      this.blockTimeoutId = null;
    }
  }
}
